import { createBrowserRouter, Navigate } from 'react-router-dom';
import SiteLayout from '@/components/layout/SiteLayout';
import BareLayout from '@/components/layout/BareLayout';
import { RouteError } from '@/components/ErrorScreen';
import ApplicationRoute from '@/routes/ApplicationRoute';
import ProgramFormRedirect from '@/routes/ProgramFormRedirect';
import { lazyWithRetry } from '@/lib/chunkLoad';
import Home from '@/pages/Home';

const Events = lazyWithRetry(() => import('@/pages/events/Events'));
const EventDetail = lazyWithRetry(() => import('@/pages/events/EventDetail'));
const Press = lazyWithRetry(() => import('@/pages/press/Press'));
const PressDetail = lazyWithRetry(() => import('@/pages/press/PressDetail'));
const Contact = lazyWithRetry(() => import('@/pages/Contact'));
const CommunityIntro = lazyWithRetry(
  () => import('@/pages/programs/CommunityIntro'),
);
const Mentorship = lazyWithRetry(() => import('@/pages/forms/Mentorship'));
const ProgramCategory = lazyWithRetry(
  () => import('@/pages/programs/ProgramCategory'),
);
const CompletedProjects = lazyWithRetry(
  () => import('@/pages/programs/CompletedProjects'),
);
const ProgramDetail = lazyWithRetry(
  () => import('@/pages/programs/ProgramDetail'),
);
const Corporate = lazyWithRetry(() => import('@/pages/Corporate'));
const Radar = lazyWithRetry(() => import('@/pages/Radar'));
const DynamicForm = lazyWithRetry(() => import('@/pages/forms/DynamicForm'));
const NotFound = lazyWithRetry(() => import('@/pages/NotFound'));

// HER üst rotada errorElement ŞART: yoksa React Router kendi "Unexpected
// Application Error!" ekranını çiziyor ve Google bu metni sayfa başlığı/özeti
// olarak indeksliyordu (bkz. ErrorScreen, lib/chunkLoad).
const router = createBrowserRouter([
  {
    path: '/',
    element: <SiteLayout />,
    errorElement: <RouteError />,
    children: [
      {
        // Yolsuz sarmalayıcı: sayfa hatası navbar/footer KORUNARAK yalnızca
        // içerik alanında gösterilir. SiteLayout'un kendisi çökerse üstteki
        // errorElement devreye girer.
        errorElement: <RouteError />,
        children: [
          { index: true, element: <Home /> },
          { path: 'institutional', element: <Corporate /> },
          // Tamamlanan Projeler artık tek sayfa (alt program sayfaları yok).
          { path: 'programs/projects', element: <CompletedProjects /> },
          { path: 'programs/:category', element: <ProgramCategory /> },
          { path: 'program/:slug', element: <ProgramDetail /> },
          { path: 'events', element: <Events /> },
          { path: 'events/:id', element: <EventDetail /> },
          { path: 'press', element: <Press /> },
          { path: 'press/:id', element: <PressDetail /> },
          { path: 'radar', element: <Radar /> },
          { path: 'contact', element: <Contact /> },
          // Teknik Gezi'nin koda gömülü başvuru sayfası KALDIRILDI: başvuru
          // artık panelden yönetilen dinamik forma gider. Eski adres o forma
          // taşınır; form yayında değilse kurumsal sayfaya düşer.
          {
            path: 'technical-visit',
            element: (
              <ProgramFormRedirect
                slug="technical-visit"
                fallback="/institutional"
              />
            ),
          },
          { path: 'community', element: <CommunityIntro /> },
          // Eklem'in koda gömülü başvuru sayfası KALDIRILDI: başvuru artık
          // panelden yönetilen dinamik forma (/form/<id>) gider. Eski
          // bağlantılar kırılmasın diye adres tanıtım sayfasına yönlendirilir;
          // oradaki buton forma götürür.
          {
            path: 'community/basvuru',
            element: <Navigate to="/community" replace />,
          },
          {
            path: 'mentorship',
            element: (
              <ApplicationRoute
                program="mentorship"
                redirectTo="/program/mentor-pool"
              >
                <Mentorship />
              </ApplicationRoute>
            ),
          },
        ],
      },
    ],
  },
  {
    // Navbar/footer olmadan, tek başına tam ekran başvuru formu.
    path: '/form/:id',
    element: <BareLayout />,
    errorElement: <RouteError />,
    children: [{ index: true, element: <DynamicForm /> }],
  },
  {
    // 404 — navbar/footer OLMADAN tam ekran (BareLayout).
    // DİKKAT: splat ('*') ebeveynin altında `index` EŞLEŞMEZ (splat kalan yolu
    // tüketir) → çocuk da '*' olmalı.
    path: '*',
    element: <BareLayout />,
    errorElement: <RouteError />,
    children: [{ path: '*', element: <NotFound /> }],
  },
]);

export default router;
